import Landing from './views/Landing.vue'
import Guide from './views/Guide.vue'

export default [
  { path: '/', component: Landing },
  { path: '/guide', component: Guide }
]



// WEBPACK FOOTER //
// ./src/routes.js